import { api } from "api/api";
import { AxiosError } from "axios";

export default class GoogleDriveService {
    enviarCodigo(code: string) {
        return new Promise<void>((resolve, reject): void => {
            let url = `/googleDrive/code`;
            api
                .post(url, {
                    code: code,
                    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
                    clientSecret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET
                })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    validarAcesso() {
        return new Promise<boolean>((resolve, reject): void => {
            let url = `/googleDrive/validar`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}